import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import "./nav.css"

class MainNav extends Component {
    handleRefresh = () => {
        window.location.reload();
      };
    render() {
        return (
            <Navbar id="main-nav">
                <Navbar.Brand className="navBrand" href="#" onClick={this.handleRefresh}>
                    <span className="icon">SC</span>
                </Navbar.Brand>

                <Nav className="ms-auto" id="navbar-link">
                    <Nav.Link className="main-link" href="https://github.com/scclark85" target="_blank"><i className="fa-brands fa-github fa-lg"></i></Nav.Link>
                    <Nav.Link className="main-link" href="https://www.linkedin.com/in/sarah-c-clark/" target="_blank"><i className="fa-brands fa-linkedin-in"></i></Nav.Link>
                    <Nav.Link className="main-link" href="mailto: sarahchristinec85@gmail.com"><i className="fa-regular fa-envelope fa-lg"></i></Nav.Link>
                </Nav>
            </Navbar>
        )
    }
}

export default MainNav;
